import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const SettingsView: FC = () => (
  <Suspense><LazySettingsView/></Suspense>
);

const LazySettingsView = lazy(importView(
  () => import("../components/SettingsView"),
  (it) => it.SettingsView,
));
